import styled, { css } from 'styled-components'
import {
  Checkbox,
  Modal as ModalUnstyled,
  OrderedBreadcrumbs as OrderedBreadcrumbsUnstyled,
  Skeleton,
} from '@sketch/components'
import { breakpoint } from '@sketch/global-styles'

// Height is shared with the document list
export const HEIGHT = '350px'

export const FullWidthContainer = styled.div<{ $noBorder?: boolean }>`
  position: relative;
  /* Make this container touch the sides of the modal */
  margin: 0 -32px;
  padding-top: 8px;
  overflow: hidden;

  ${({ $noBorder }) =>
    !$noBorder &&
    css`
      border-top: 1px solid ${({ theme }) => theme.colors.border.A};
    `}
`

export const OrderedBreadcrumbs = styled(OrderedBreadcrumbsUnstyled)`
  margin-top: 12px;

  ${breakpoint('base', 'xs')`
    margin-top: 0px;
  `}
`

export const TabsContainer = styled.div`
  display: flex;
  margin-top: 4px; /* 20px of the modal padding + 4px top margin = 24px (same as margin bottom) */
  margin-bottom: 24px;
`

export const CounterContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 16px 16px;
`

export const Modal = styled(ModalUnstyled)`
  max-width: 640px;
`

export const ModalBody = styled(ModalUnstyled.Body)<{ $step?: number }>`
  padding: 0 16px 0 16px;

  min-height: ${({ $step }) => ($step !== 0 ? '620px' : 'auto')};

  ${breakpoint('sm')`
    padding: 0 32px 0 32px;
  `}
`

export const SelectAllCheck = styled(Checkbox)`
  span {
    margin-right: 0;
  }
`

export const Title = styled.h1`
  font-size: ${({ theme }) => theme.fontSizes.G};
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
  margin: 0 0 4px;
`

export const Description = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.E};
  color: ${({ theme }) => theme.colors.foreground.secondary.C};
`

export const TabSkeleton = styled(Skeleton)`
  width: 180px;
  height: 32px;
  margin-left: 8px;
  border-radius: ${({ theme }) => theme.radii.large};
  /* Avoids a flicker when the skeleton disappears */
  margin-bottom: -5px; /* stylelint-disable-line scales/space */
`
